<template>
    <div class="alevel_home">
        <div class="a1">
            <div class="a1_cont">
                <div class="p1">国际课程</div>
                <div class="p2">A-LEVEL</div>
                <div class="p3">培生爱德思考试局官方授权办学中心、考试中心</div>
            </div>
        </div>
        <div class="a2">
            <div class="a2_cont">
                <div class="a2_item" @click="scrolla2item(0)">
                    <img src="../img/alevel/Star 2.png" alt="">
                    <p>A-LEVEL课程介绍</p>
                </div>
                <div class="a2_item" @click="scrolla2item(1)">
                    <img src="../img/alevel/Star 2.png" alt="">
                    <p>A-LEVEL课程优势</p>
                </div>
                <div class="a2_item" @click="scrolla2item(2)">
                    <img src="../img/alevel/Star 2.png" alt="">
                    <p>RoSSo的服务与优势</p>
                </div>
                <div class="a2_item" @click="scrolla2item(3)">
                    <img src="../img/alevel/Star 2.png" alt="">
                    <p>官方资料参考</p>
                </div>
            </div>
        </div>

        <div class="a3">
            <div class="a2_position"></div>
            <div class="a3_title_box">
                <div class="a3_title_cn">A-LEVEL课程介绍</div>
                <div class="a3_title_en">A-LEVEL COURSE INTRODUCTION</div>
            </div>
            <div class="a3_cont">
                英国高中课程General Certificate of Education Advanced Level 简称A-Level课程，是英国学生的大学入学考试课程,
                其重要性等同于中国高考。<span>A-level课程适合16～19 周岁（ 初中毕业 / 高中在读 ）的青少年，无艺术基础及语言要求。</span> <br><br>
                目前，使用A
                Level考试成绩可向世界上超过110个国家和地区的大学进行入学申请和奖学金申请，包括<span>英国、美国、加拿大、澳大利亚、新西兰、香港、新加坡</span>等中国学生热门选择的留学国家和地区。被誉为“全球大学入学的金牌标准”和通往顶尖大学的通行证，适合全球的高中学生学习。<br><br>
                培生爱德思是英国最大的学术及职业考试认证机构。目前，培生爱德思为超过80个国家和地区的170多万人提供国际考试认证服务。作为全球领先的教育集团之⼀，培生已有超170年的历史，致力于为教育工作者和学生提供优质的教育资源和教育服务。
            </div>
            <div class="a3_img">
                <img src="../img/alevel/alevel.jpg" alt="">
                <p>* RoSSo荣获爱德思考试局官方授权 <br>成为A Level的官方办学中心和考试中心</p>
            </div>
        </div>
        <div class="a4">
            <div class="a2_position"></div>
            <div class="a3_title_box">
                <div class="a3_title_cn">A-LEVEL课程优势</div>
                <div class="a3_title_en">A-LEVEL COURSE ADVANTANGE</div>
            </div>
            <div class="a4_cont">
                <div class="swiper mySwiperA1">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <div class="a4_item">
                                <div class="a4_item_nei">
                                    <p class="p1">自主选课机制</p>
                                    <p class="p2">A Level艺术科目是申请英国本科艺术类专业必不可少的条件，匹配英美院校本科入学要求。</p>
                                </div>
                                <img src="../img/alevel/Group 632.png" alt="">
                            </div>
                            <div class="a4_item">
                                <div class="a4_item_nei">
                                    <p class="p1">灵活考试形式</p>
                                    <p class="p2">A Level艺术科目的考试形式灵活，以作品创作为主，有助于艺术方向的学生发挥自身特长，在考试中占据得分优势。</p>
                                </div>
                                <img src="../img/alevel/Group 633.png" alt="">
                            </div>
                            <div class="a4_item">
                                <div class="a4_item_nei">
                                    <p class="p1">本科入学必要条件</p>
                                    <p class="p2">A Level艺术科目是申请英国本科艺术类专业必不可少的条件，匹配英美院校本科入学要求。</p>
                                </div>
                                <img src="../img/alevel/Group 635.png" alt="">
                            </div>
                            <div class="a4_item">
                                <div class="a4_item_nei">
                                    <p class="p1">提前适应国外教育模式</p>
                                    <p class="p2">引导学生提前适应国外艺术教育模式和评价体系，为后续本科、研究生阶段的专业学习夯实基础。</p>
                                </div>
                                <img src="../img/alevel/Group 636.png" alt="">
                            </div>

                        </div>
                        <div class="swiper-slide">
                            <div class="a4_item">
                                <div class="a4_item_nei">
                                    <p class="p1">提高申请竞争力</p>
                                    <p class="p2">可以有效弥补文理学科成绩的不足，提升整体成绩水平和申请竞争力。</p>
                                </div>
                                <img src="../img/alevel/Group 634.png" alt="">
                            </div>
                            <div class="a4_item">
                                <div class="a4_item_nei">
                                    <p class="p1">多维度拓展艺术能力</p>
                                    <p class="p2">开设多门艺术学科，学生可匹配自身兴趣爱好，多维度拓展艺术领域技能和知识。</p>
                                </div>
                                <img src="../img/alevel/Group 637.png" alt="">
                            </div>
                            <div class="a4_item">
                                <div class="a4_item_nei">
                                    <p class="p1">深入培养艺术思维&创造力</p>
                                    <p class="p2">通过A Level课程，学生可以学到有深度的艺术知识，培养艺术思维和创造力；并在学习过程中获得专业的指导、评估及阶段性审核反馈。 </p>
                                </div>
                                <img src="../img/alevel/Group 540.png" alt="">
                            </div>
                            <div class="a4_item" style="background-color: #fff7e9;"></div>
                        </div>

                    </div>
                    <div class="swiper-pagination"></div>
                </div>
            </div>
        </div>
        <div class="a5">
            <div class="a3_title_box">
                <div class="a3_title_cn">A-LEVEL开设科目</div>
                <div class="a3_title_en">A-LEVEL SUBJECT</div>
            </div>
            <div class="a5_title">
                RoSSo依据爱德思Art and Design官方考纲，集结海归名校导师，对A Level 艺术科目进行深度教研。依托优质的艺术教育资源和丰富的行业经验，为学生提供专业的国际课程教育。
            </div>
            <div class="a5_cont">
                <div class="a5_item">
                    <img src="../img/alevel/Rectangle 1088.jpg" alt="">
                    <div class="a5_item_nei">
                        <p class="p1">纯艺</p>
                        <p class="p2">Fine Art</p>
                    </div>
                </div>
                <div class="a5_item">
                    <img src="../img/alevel/Rectangle 1089.jpg" alt="">
                    <div class="a5_item_nei">
                        <p class="p1">摄影</p>
                        <p class="p2">Photography</p>
                    </div>
                </div>
                <div class="a5_item">
                    <img src="../img/alevel/Rectangle 1091.jpg" alt="">
                    <div class="a5_item_nei">
                        <p class="p1">纺织</p>
                        <p class="p2">Textiles</p>
                    </div>
                </div>
                <div class="a5_item">
                    <img src="../img/alevel/Rectangle 1092.jpg" alt="">
                    <div class="a5_item_nei">
                        <p class="p1">3D设计</p>
                        <p class="p2">3-Dimensional Design</p>
                    </div>
                </div>
                <div class="a5_item">
                    <img src="../img/alevel/Rectangle 1090.jpg" alt="">
                    <div class="a5_item_nei">
                        <p class="p1">平面设计</p>
                        <p class="p2">Graphic Design</p>
                    </div>
                </div>
                <div class="a5_item">
                    <!-- <img src="" alt=""> -->
                    <div class="a5_item_nei"></div>
                </div>
            </div>
        </div>
        <div class="a6">
            <div class="a2_position"></div>
            <div class="a3_title_box">
                <div class="a3_title_cn">RoSSo独家优势</div>
                <div class="a3_title_en">RoSSo EXCLUSIVE ADVANTAGE</div>
            </div>
            <div class="a6_cont">
                <div class="swiper mySwiperA1">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <div class="a6_item">
                                <p class="p1">官方认证，质量保证</p>
                                <p class="p2">• RoSSo是爱德思考试局官方授权的A Level办学中心、考试中心</p>
                            </div>
                            <div class="a6_item">
                                <p class="p1">海归名师，精心教研</p>
                                <p class="p2">• 集结海归名师，匹配爱德思Art and Design官方考纲，精心教研，提供专业教育</p>
                            </div>
                            <div class="a6_item">
                                <p class="p1">优质资源，丰富经验</p>
                                <p class="p2">• 依托优质的艺术教育资源和丰富的国际课程教学经验，帮助学生占据优势</p>
                            </div>
                            <div class="a6_item">
                                <p class="p1">专业团队，严格把控</p>
                                <p class="p2">• 专业的教学和审核团队，严格把控学习进度，为学生提供阶段性审核及反馈</p>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            
                            <div class="a6_item">
                                <p class="p1">学术&申请，高效同步</p>
                                <p class="p2">• A Level成绩和作品集双重把控，学术考试和大学申请高效同步</p>
                            </div>
                            <div class="a6_item">
                                <p class="p1">丰富课程，多维拓展</p>
                                <p class="p2">• RoSSo开设多门A Level艺术学科，学生可根据自身兴趣和未来发展规划，多维度拓展艺术技能。</p>
                            </div>
                            <div class="a6_item">
                                <p class="p1">不出国门，高性价比</p>
                                <p class="p2">• 在国内学习英国高中课程，省时省力，超高性价比</p>
                            </div>
                            <div class="a6_item">
                                <p class="p1">无需语言，即可入读</p>
                                <p class="p2">• 入读无需雅思/托福成绩，循序渐进适应英国教育体系</p>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-pagination"></div>
                </div>
            </div>
        </div>
        <div class="a7">
            <div class="a3_title_box">
                <div class="a3_title_cn">课程亮点</div>
                <div class="a3_title_en">COURSE ADVANTAGE</div>
            </div>
            <div class="a7_cont">
                <div class="a7_item">
                    <img src="../img/alevel/Rectangle 1098.jpg" alt="">
                    <p>一对一授课，定制化教学辅导<br> 课程时间灵活安排</p>
                </div>
                <div class="a7_item">
                    <img src="../img/alevel/Rectangle 1105.jpg" alt="">
                    <p>精心研读官方考纲，<br> 考点全面拆解，核心内容教学</p>
                </div>
                <div class="a7_item">
                    <img src="../img/alevel/Rectangle 1103.jpg" alt="">
                    <p>课前基础评估, 因材施教</p>
                </div>
                <div class="a7_item">
                    <img src="../img/alevel/Rectangle 1106.jpg" alt="">
                    <p>阶段性审核反馈,<br> 实现阶梯式成长</p>
                </div>
              
                
            </div>
        </div>
        <div class="a9">
            <div class="a3_title_box">
                <div class="a3_title_cn">获奖证书 & A*成绩单</div>
                <div class="a3_title_en">AWARDS CERTIFICATION</div>
            </div>
            <div class="a9_cont">
                <div class="a9_award">
                    <div class="award_item">
                        <div class="award_item_img"><img src="../img/alevel/wecom-1.png"/></div>
                        <div class="award_item_text">RoSSo Gui同学<br/>斩获2024年A Level摄<br/>影中国区最高分</div>
                    </div>
                    <div class="award_item">
                        <div class="award_item_img"><img src="../img/alevel/wecom-3.png"/></div>
                        <div class="award_item_text">RoSSo荣获<br/>2024年培生<br/>“杰出学校奖”</div>
                    </div>
                    <div class="award_item">
                        <div class="award_item_img"><img src="../img/alevel/wecom-2.png"/></div>
                        <div class="award_item_text">RoSSo Cao同学<br/>斩获2024年GCSE摄影<br/>中国区最高分</div>
                    </div>
                </div>
                <div class="swiper mySwiperA">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <div class="a5_item">
                                <img src="../img/alevel/4_01.png"/>
                            </div>
                            <div class="a5_item">
                                <img src="../img/alevel/6_01.png"/>
                            </div>
                            <div class="a5_item">
                                <img src="../img/alevel/7_01.png"/>
                            </div>
                            <div class="a5_item">
                                <img src="../img/alevel/10_01.png"/>
                            </div>
                            <div class="a5_item">
                                <img src="../img/alevel/17_01.png"/>
                            </div>
                            <div class="a5_item">
                                <img src="../img/alevel/20_01.png"/>
                            </div>
                            <div class="a5_item">
                                <img src="../img/alevel/24_01.png"/>
                            </div>
                            <div class="a5_item">
                                <img src="../img/alevel/32_01.png"/>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="a5_item">
                                <img src="../img/alevel/Alevel奖状模版_03.png"/>
                            </div>
                            <div class="a5_item">
                                <img src="../img/alevel/Alevel奖状模版_14.png"/>
                            </div>
                            <div class="a5_item">
                                <img src="../img/alevel/Alevel奖状模版_15.png"/>
                            </div>
                            <div class="a5_item">
                                <img src="../img/alevel/Alevel奖状模版_16.png"/>
                            </div>
                            <div class="a5_item">
                                <img src="../img/alevel/Alevel奖状模版_18.png"/>
                            </div>
                            <div class="a5_item">
                                <img src="../img/alevel/Alevel奖状模版_20.png"/>
                            </div>
                            <div class="a5_item">
                                <img src="../img/alevel/Alevel奖状模版_22.png"/>
                            </div>
                            <div class="a5_item">
                                <img src="../img/alevel/Alevel奖状模版_28.png"/>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-pagination"></div>
                </div>
            </div>
        </div>
        <div class="a8">
            <div class="a2_position"></div>
            <div class="a3_title_box">
                <div class="a3_title_cn">官方资料参考</div>
                <div class="a3_title_en">OFFICIAL DOCUMENT REFERENCE</div>
            </div>
            <div class="a5_cont">
                <div class="a5_item">
                    <div class="a5_item_show" @click="a5Show(0)">
                        <div class="a5_item_show_title">• 英国大学艺术专业 本科入学要求参考</div>
                        <div class="cha" style=" transform: rotate(225deg);">
                            <div class="cha_line1"></div>
                            <div class="cha_line2"></div>
                        </div>
                    </div>

                    <div class="grid" style="grid-template-rows: 1fr;">
                        <div class="a5_item_hid">
                            <div class="a5_item_hid_table">
                                <table>
                                    <tr style="font-weight: bold;">
                                        <td style="width: 1.64rem;font-size: .22rem;background-color: #DFB476;padding: .1rem;">专业
                                        </td>
                                        <td style="width: 1.15rem;font-size: .22rem;background-color: #DFB476;padding: .1rem;">院校
                                        </td>
                                        <td style="width: 3.47rem;font-size: .22rem;background-color: #DFB476;padding: .1rem;">
                                            录取要求</td>
                                    </tr>
                                    <tr>
                                        <td>珠宝设计<br>Jewellery <br>Design</td>
                                        <td class="td16">中央圣马丁艺术设计学院</td>
                                        <td>
                                            “Three A Levels at grades ABC (at least one subject must include Art, Art and
                                            Design or Design and Technology)” <br>
                                            <p>*三个A-Level成绩为ABC（至少一门艺术方向学科）</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>服装设计 <br>Fashion Design<br> Technology: Womenswear</td>
                                        <td class="td16">伦敦时装学院</td>
                                        <td>
                                            “Two A Level Passes at Grade C or above (preferred subjects include, Art,
                                            Design, Maths)” <br>
                                            <p>*首选科目包括，艺术、设计、数学 </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>纯艺 <br>Fine Art</td>
                                        <td>中央圣马丁艺术设计学院</td>
                                        <td>“2 A Levels at grade C or above (preferred subjects include Art, Art and Design,
                                            or Design and Technology)” <br>
                                            <p>*推荐科目：Art, Art and Design, or Design and Technology</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>产品设计 <br>Product Design</td>
                                        <td>中央圣马丁艺术设计学院</td>
                                        <td>“3 A Levels at grades ABC (preferred subjects include Art, Art and Design, or
                                            Design and Technology)” <br>
                                            <p>*推荐科目：Art, Art and Design, or Design and Technology</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>建筑<br> Architecture</td>
                                        <td>伦敦大学学院</td>
                                        <td>“3 A Levels at grades AAB”</td>
                                    </tr>
                                </table>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="a5_item">
                    <div class="a5_item_show" @click="a5Show(1)">
                        <div class="a5_item_show_title">• A-LEVEL 课程体系</div>
                        <div class="cha">
                            <div class="cha_line1"></div>
                            <div class="cha_line2"></div>
                        </div>
                    </div>
                    <div class="grid">
                        <div class="a5_item_hid">
                            <div class="a5_item2_title">
                                A Level证书对应英国国家证书体系的3级（Level 3), 获得A Level证书相当于达到了英国的高中教育水平。
                            </div>
                            <div class="a5_item2_table">
                                <table>
                                    <tr>
                                        <td
                                            style="width: 3.08rem;font-size:0.22rem;font-weight:bold;background-color: #DFB476;padding: .1rem;">
                                            英国国家证书体系级别</td>
                                        <td
                                            style="width: 2.59rem;font-size:.22rem;font-weight:bold;background-color: #DFB476;padding: .1rem;">
                                            对应中国学生年龄</td>
                                        <td
                                            style="width: 4.26rem;font-size:.22rem;font-weight:bold;background-color: #DFB476;padding: .1rem;">
                                            培生国际资格证书体系</td>
                                    </tr>
                                    <tr>
                                        <td>3级</td>
                                        <td>16岁以上</td>
                                        <td>英国中学高级水平证书<br>
                                            GCE A Levels / IAL</td>
                                    </tr>
                                    <tr>
                                        <td>2级</td>
                                        <td>14-16岁</td>
                                        <td>英国普通中等水平证书<br>
                                            GCSE / IGCSE</td>
                                    </tr>
                                    <tr>
                                        <td>1级</td>
                                        <td>12-14岁</td>
                                        <td>英国国际中学课程<br>
                                            Lower Secondary Curriculum</td>
                                    </tr>
                                    <tr>
                                        <td>预备级</td>
                                        <td>8-11岁</td>
                                        <td>英国国际小学课程<br>
                                            Primary Curriculum</td>

                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="a5_item">
                    <div class="a5_item_show" @click="a5Show(2)">
                        <div class="a5_item_show_title">• 考试评估标准</div>
                        <div class="cha">
                            <div class="cha_line1"></div>
                            <div class="cha_line2"></div>
                        </div>
                    </div>
                    <div class="grid">
                        <div class="a5_item_hid">
                            <div class="a5_item3_hid_cont">
                                <div class="a5_item3_hid_title"> 第一部分： Personal Investigation<br>评估占比：60%</div>
                                <div class="a5_item3_hid_box">
                                    <img src="../img/alevel/Group 6611.png" alt="">
                                    <div>
                                        评估内容包含：<br>
                                        1. Supporting Studies 灵感调研<br>
                                        2. Practical Work 成品制作<br>
                                        3. Personal Study调研文章<br>
                                        评估命题：自拟
                                    </div>
                                </div>
                            </div>
                            <div class="a5_item3_line"></div>
                            <div class="a5_item3_hid_cont">
                                <div class="a5_item3_hid_title"> 第二部分： Personal Investigation<br>评估占比：40%</div>
                                <div class="a5_item3_hid_box">
                                    <img src="../img/alevel/Group 6622.png" alt="">
                                    <div>
                                        评估内容包含：<br>
                                        1. 前期调研（sketchbook形式，课堂中导师指导下完成）<br>
                                        2. 成品制作（考场内完成）<br>
                                        评估命题：由Pearson规定（2月1日发放题目）
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section_inp">
            <div class="s_inp_left">
                <img src="../img/Group 302.png" alt="" class="img_shou" id="imgText">
            </div>
            <div class="s_inp_right">
                <el-form :inline="true" :label-position="labelPosition" label-width="1.2rem" :model="formLabelAlign"
                    style="justify-content: center;">
                    <el-form-item label="姓名：">
                        <el-input v-model="formLabelAlign.name" placeholder="输入姓名"></el-input>
                    </el-form-item>

                    <el-form-item label="意向专业：">
                        <el-input v-model="formLabelAlign.major" placeholder="意向专业"></el-input>
                    </el-form-item>
                    <el-form-item label="电话：">
                        <el-input v-model="formLabelAlign.tel" placeholder="输入电话号"></el-input>
                    </el-form-item>
                    <el-form-item label="意向国家：" class="elitem2">
                        <el-select v-model="formLabelAlign.region2" placeholder="国家">
                            <el-option label="英国" value="England"></el-option>
                            <el-option label="美国" value="America"></el-option>
                            <el-option label="日本" value="Japan"></el-option>
                            <el-option label="新加坡" value="Singapore"></el-option>
                            <el-option label="韩国" value="Korea"></el-option>
                            <el-option label="欧洲" value="Europe"></el-option>
                           
                            <el-option label="其他" value="Other"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <div class="yuyue" @click="onSubmit()"></div>
                    </el-form-item>
                </el-form>
            </div>

        </div>
        <!-- 最外层 -->
    </div>
</template>
<script>
import Swiper from 'swiper/bundle'
// import  Swiper from 'swiper/vue';
import 'swiper/css';
import "swiper/css/effect-cards";
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import axios from "axios"
import "@/assets/css/alevel.css"
export default {
    data() {
        return {
            labelPosition: 'right',
            formLabelAlign: {
                name: '',
                tel: '',
                region: '',
                region2: '',
                budget: '',
            },
        }
    },
    created() {

    },
    methods: {
        scrolla2item(val){
            // console.log(val);
            var a2_position = document.getElementsByClassName("a2_position")
            var a2_left_item = document.getElementsByClassName("a2_item")
            for(var i =0;i<a2_left_item.length;i++){
                a2_left_item[i].style.opacity = "0.5"
            }
            console.log(a2_position);
            a2_left_item[val].style.opacity = "1"
            a2_position[val].scrollIntoView({
                block: 'start',
                behavior: 'smooth',

            })
        },
        onSubmit() {
            var currentURL = window.location.href;
            var status = ''
            // 检查 URL 中是否包含某些关键词，来判断使用的搜索引擎
            if (currentURL.includes("google.com")) {
                status = "用户正在使用 Google 搜索引擎"
            } else if (currentURL.includes("bing.com")) {
                status = "用户正在使用 Bing 搜索引擎"
            } else if (currentURL.includes("yahoo.com")) {
                status = "用户正在使用 Yahoo 搜索引擎"
            } else if (currentURL.includes("baidu.com")) {
                status = "用户正在使用 百度 搜索引擎"
            } else {
                status = "无法确定用户使用的搜索引擎"
            }
            var patt = /^1[3-9][0-9]{9}$/
            if (this.formLabelAlign.name == "" || this.formLabelAlign.tel == "") {
                // console.log("姓名和手机号不能为空");
                this.$message.error('姓名和手机号不能为空');
            } else {
                // console.log("不是空");
                if (patt.test(this.formLabelAlign.tel)) {
                    // console.log("可以发请求");
                    // console.log(this.formInline);
                    axios.post("https://public.rossoarts.com/index/common/getform", {
                        "name": this.formLabelAlign.name,
                        "tel": this.formLabelAlign.tel,
                        "major": this.formLabelAlign.major,
                        "intended_country":this.formLabelAlign.region2,
                        "url": window.location.href,
                        "status":status,
                    }).then((data) => {
                        console.log(data, "response");
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    }).catch(function (error) {
                        console.log(error, "error");
                    });
                } else {
                    console.log("手机号格式不正确");
                    this.$message.error('手机号格式不正确');
                }
            }
        },
        a5Show(val) {
            // console.log(val);
            var cha = document.getElementsByClassName("cha")
            var grid = document.getElementsByClassName("grid")
            // var t6_item_show = document.getElementsByClassName("t6_item_show")
            // var t6_imgQ = document.getElementsByClassName("t6_imgQ")
            // this.flag = !this.flag
            // console.log(grid[val].style.gridTemplateRows,val);
            if (grid[val].style.gridTemplateRows == "1fr") {
                // 折叠
                // console.log("不出");
                grid[val].style.gridTemplateRows = "0fr";
                cha[val].style.transform = "rotate(0deg)"
                // t6_item_show[val].style.backgroundColor = "#5f9df7"
                // t6_item_show[val].style.border = "none"
                // t6_item_show[val].style.margin = "0rem"
                // t6_imgQ[val].style.visibility = "visible"
            } else {
                // 展开
                // console.log("出");
                grid[val].style.gridTemplateRows = "1fr";
                cha[val].style.transform = "rotate(225deg)"
                // t6_item_show[val].style.backgroundColor = "#FB6333"
                // t6_item_show[val].style.border = ".02rem solid #000"
                // t6_item_show[val].style.margin = "-0.02rem -0.02rem 0 -0.02rem"
                // t6_imgQ[val].style.visibility = "hidden"

            }
        },
    },
    mounted() {
        var swiper = new Swiper(".mySwiperA1", {
            loop: true,
            pagination: {
                clickable: true,
                el: ".swiper-pagination",
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
        var swiperA = new Swiper(".mySwiperA", {
            loop: true,
            pagination: {
                clickable: true,
                el: ".swiper-pagination",
            },
        })
    }
}
</script>